import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", { class: "pt-8 pb-2" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-light font-roboto text-blue-700" }, "Kasutaja seaded")
], -1)
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserNameChange = _resolveComponent("UserNameChange")!
  const _component_UserEmailChange = _resolveComponent("UserEmailChange")!
  const _component_UserPhoneChange = _resolveComponent("UserPhoneChange")!
  const _component_UserPasswordChange = _resolveComponent("UserPasswordChange")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_UserNameChange),
      _hoisted_4,
      _createVNode(_component_UserEmailChange),
      _hoisted_5,
      _createVNode(_component_UserPhoneChange),
      _hoisted_6,
      _createVNode(_component_UserPasswordChange)
    ])
  ]))
}